import { render, staticRenderFns } from "./Book2FeePanel.vue?vue&type=template&id=ffad97d4&scoped=true&"
import script from "./Book2FeePanel.vue?vue&type=script&lang=js&"
export * from "./Book2FeePanel.vue?vue&type=script&lang=js&"
import style0 from "./Book2FeePanel.vue?vue&type=style&index=0&id=ffad97d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffad97d4",
  null
  
)

export default component.exports